import commonEn from './locales/en/common.json';
import coreEn from './locales/en/core.json';
import errorsEn from './locales/en/errors.json';
import modulesEn from './locales/en/modules.json';
import smtpEn from './locales/en/smtp.json';
import commonIt from './locales/it/common.json';
import coreIt from './locales/it/core.json';
import errorsIt from './locales/it/errors.json';
import modulesIt from './locales/it/modules.json';
import smtpIt from './locales/it/smtp.json';

/** Translations every web app needs: common words, API errors, the module names (one list, so
 *  console and Control Center call a module the same way), the outgoing mail form. Each app
 *  spreads them into its own tree (`common.*`, `core.*`, `errors.*`, `modules.*`, `smtp.*`). */
export const coreTranslations = {
  it: { common: commonIt, core: coreIt, errors: errorsIt, modules: modulesIt, smtp: smtpIt },
  en: { common: commonEn, core: coreEn, errors: errorsEn, modules: modulesEn, smtp: smtpEn },
};
